import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

interface HeadlineMetaProps {
  /** Each part is its figure, then what the figure counts. */
  parts: { figure: string; qualifier: string }[];
}

/**
 * A headline tile's caption: semibold figures, each followed by its qualifier,
 * split by the same dot the package StatCard puts between value and caption.
 */
const HeadlineMeta: React.FC<HeadlineMetaProps> = ({ parts }) => (
  <>
    {parts.map(({ figure, qualifier }, index) => (
      <React.Fragment key={`${figure} ${qualifier}`}>
        {index > 0 && (
          <Box
            component="span"
            aria-hidden
            sx={{
              mx: 0.75,
              fontSize: "var(--type-size-sm)",
              lineHeight: "var(--type-line-height-tight)",
            }}
          >
            •
          </Box>
        )}
        <Typography
          component="span"
          variant="inherit"
          sx={{
            fontWeight: "var(--type-weight-semibold)",
            color: "var(--color-text-primary)",
          }}
        >
          {figure}
        </Typography>
        {` ${qualifier}`}
      </React.Fragment>
    ))}
  </>
);

export default HeadlineMeta;
